import type { HelpFile } from '../../types/help'
import { ServiceAccountDetailTestIds } from '../../../testids/ServiceAccountDetailTestIds'

export const serviceAccountDetailHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [ServiceAccountDetailTestIds.serviceAccountDetailPage]:
      'Detail page for a single service account — overview, API keys, and assigned roles.',
    [ServiceAccountDetailTestIds.cardOverview]:
      'Core service-account metadata: name, description, status, when it was created, and how many API keys are currently active.',
    [ServiceAccountDetailTestIds.cardOverviewTitle]: null,
    [ServiceAccountDetailTestIds.cardApiKeysTitle]: null,
    [ServiceAccountDetailTestIds.cardRolesTitle]: null,
    [ServiceAccountDetailTestIds.cardApiKeys]:
      'API keys minted for this service account. Each key carries the same authorization roles as the account itself.',
    [ServiceAccountDetailTestIds.cardRoles]:
      'Authorization roles assigned to this service account. Use the Assign Role button to grant additional roles; click Remove on a row to revoke one.',
    [ServiceAccountDetailTestIds.btnEditServiceAccount]:
      'Edit the service-account name and description. Changing the name does not invalidate existing API keys.',
    [ServiceAccountDetailTestIds.btnDeactivateServiceAccount]:
      'Deactivate this service account and immediately revoke all its active API keys. The account can be reactivated later — keys must be re-minted.',
    [ServiceAccountDetailTestIds.btnReactivateServiceAccount]:
      'Restore this service account to active status. Existing keys remain revoked; mint new keys to allow API access.',
    [ServiceAccountDetailTestIds.btnMintApiKey]:
      'Mint a new API key for this service account. The raw key is shown exactly once and is not stored — copy it before closing.',
    [ServiceAccountDetailTestIds.btnMintEmpty]: null,
    [ServiceAccountDetailTestIds.apiKeysEmpty]: null,
    [ServiceAccountDetailTestIds.apiKeysError]: null,
    [ServiceAccountDetailTestIds.rolesEmpty]: null,
    [ServiceAccountDetailTestIds.badgeDetailStatus]:
      'Current status of the service account — Active or Inactive.',
    [ServiceAccountDetailTestIds.badgeDetailActiveKeys]:
      'Count of API keys currently in the Active state for this account.',
    [ServiceAccountDetailTestIds.colKeyName]:
      'Display name given to the API key when minted.',
    [ServiceAccountDetailTestIds.colKeyPrefix]:
      'Twelve-character prefix shown for identification — the full key is never re-disclosed after mint.',
    [ServiceAccountDetailTestIds.colKeyLastUsed]:
      'Timestamp of the most recent successful authentication using this key. Empty if the key has never been used.',
    [ServiceAccountDetailTestIds.colKeyRateLimit]:
      'Per-minute request limit for the key. Default applies when no per-key override is configured.',
    [ServiceAccountDetailTestIds.colKeyStatus]:
      'Effective status: Revoked > Inactive > Expired > Active. The highest applicable state wins.',
    [ServiceAccountDetailTestIds.colKeyActions]:
      'Per-key actions — currently only Revoke for active keys.',
    [ServiceAccountDetailTestIds.btnRevokePrefix()]:
      'Permanently revoke this API key. Authentication using the key fails immediately.',
    [ServiceAccountDetailTestIds.editDialogTitle]: null,
    [ServiceAccountDetailTestIds.editForm]: null,
    [ServiceAccountDetailTestIds.editInputName]:
      'Updated service-account name (1–100 characters). Renaming preserves all existing keys.',
    [ServiceAccountDetailTestIds.editInputDescription]:
      'Updated free-text description (up to 500 characters).',
    [ServiceAccountDetailTestIds.deactivateDialogTitle]: null,
    [ServiceAccountDetailTestIds.deactivateDialogBody]: null,
    [ServiceAccountDetailTestIds.btnAssignRole]:
      'Open the Assign Role dialog to grant an additional authorization role to this service account.',
    [ServiceAccountDetailTestIds.btnAssignRoleEmpty]: null,
    [ServiceAccountDetailTestIds.rolesLoading]: null,
    [ServiceAccountDetailTestIds.rolesError]: null,
    [ServiceAccountDetailTestIds.colRoleName]:
      'Role name — links to the role detail page where you can inspect the permissions the role carries.',
    [ServiceAccountDetailTestIds.colRoleDescription]:
      'Description of the role.',
    [ServiceAccountDetailTestIds.colRoleAssignedBy]:
      'Display name of the human user who assigned the role. Empty when the row was seeded by DB testdata.',
    [ServiceAccountDetailTestIds.colRoleAssignedAt]:
      'Timestamp the role was assigned to this service account.',
    [ServiceAccountDetailTestIds.colRoleActions]:
      'Per-row actions — currently only Remove.',
    [ServiceAccountDetailTestIds.btnRemoveRolePrefix()]:
      'Open the Remove Role confirmation dialog to revoke this role from the service account.',
  },
}
